<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.article.title">
                                <Input v-model="formItem.title"
                                       :placeholder="msgUtil.placeholderRequired(t.article.title)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.article.defaultImg">
                                <Select v-model="formItem.defaultImg" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.defaultImg)">>
                                    <Option value="0">{{t.article.no}}</Option>
                                    <Option value="1">{{t.article.yes}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.article.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.status)">>
                                    <Option value="0">{{t.article.statusOption0}}</Option>
                                    <Option value="1">{{t.article.statusOption1}}</Option>
                                    <Option value="2">{{t.article.statusOption2}}</Option>
                                    <Option value="9">{{t.article.statusOption9}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.article.disabled">
                                <Select v-model="formItem.disabled" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.article.disabled)">>
                                    <Option value="0">{{t.article.yes}}</Option>
                                    <Option value="1">{{t.article.no}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="8" class="">
                            <Form-item :label="t.article.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.article.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8" class="">
                            <Form-item :label="t.article.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.article.createEndTime)"
                                            :options="createEndTimeOption" @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Form-item :label="t.article.body">
                                <Input v-model="formItem.body"
                                       :placeholder="msgUtil.placeholderRequired(t.article.body)" :maxlength="200"></Input>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="16">
                            <Form-item :label="t.article.category">
                                <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                                    <Checkbox :label="item.key" :key="item.key" v-for="item in categoryList"
                                              style="padding-left:8px;">
                                        {{item.name}}
                                    </Checkbox>
                                </CheckboxGroup>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Button type="primary" icon="ios-search" style="float:right" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                            <Button type="success" icon="ios-search" style="float:right;margin-right:10px;"
                                    @click="gotoArticleHistory()">
                                {{msgUtil.message.action.articleHistory}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <!-- name 是路由名，参考的@/router/organization/dept.js的名 -->
                    <Button icon="md-add" to="./add">{{msgUtil.message.action.add}}</Button>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
        <Modal v-model.trim="delModal" width="360" :mask="true" :mask-closable="false" :closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{t.message.delConfirmTitle}}</span>
            </p>
            <div style="text-align:center">
                <p>{{t.message.delConfirm}}</p>
            </div>
            <div slot="footer">
                <Button size="large" @click="handleDeleteCancel">
                    {{msgUtil.message.action.cancel}}
                </Button>
                <Button type="error" size="large" :loading="delModalLoading" @click="handleDelete">
                    {{msgUtil.message.action.delete}}
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {Message, Button, ButtonGroup, Tag} from 'iview';
    import {del, delAll, getArticleList} from '@/api/article';
    import sortButtonGroup from '@/components/sort-button-group.vue';

    export default {
        name: 'content_article_list',
        components: {
            sortButtonGroup,
        },
        data() {
            const t = this.$_t();
            const msgUtil = this.$msgUtil;
            const renderTitle = (h, params) => {
                const row = params.row;
                return h('div', [
                    h(
                        'router-link',
                        {
                            props: {
                                to: './detail/' + row.id,
                            },
                        },
                        row.title
                    ),
                ]);
            };
            const renderCategory = (h, params) => {
                const row = params.row;

                let hotType = row.hot !== null ? 'error' : 'info';
                let recommendType = row.recommend !== null ? 'error' : 'info';
                let recommendTopType = row.recommendTop !== null ? 'error' : 'info';
                let topicType = row.topic !== null ? 'error' : 'info';
                let sliderType = row.slider !== null ? 'error' : 'info';
                /*if(row.dictId != null){
                        hotType = 'error';
                        recommendType = 'error';
                        recommendTopType = 'error';
                        topicType = 'error';
                        sliderType = 'error';
                    }*/
                return h('button-group', [
                    h(
                        'i-button',
                        {
                            props: {
                                type: hotType,
                                size: 'small',
                                ghost: true,
                            },
                        },
                        t.table.hot
                    ),
                    h(
                        'i-button',
                        {
                            props: {
                                type: recommendType,
                                size: 'small',
                                ghost: true,
                            },
                        },
                        t.table.recommend
                    ),
                    h(
                        'i-button',
                        {
                            props: {
                                type: recommendTopType,
                                size: 'small',
                                ghost: true,
                            },
                        },
                        t.table.recommendTop
                    ),
                    h(
                        'i-button',
                        {
                            props: {
                                type: topicType,
                                size: 'small',
                                ghost: true,
                            },
                        },
                        t.table.topic
                    ),
                    h(
                        'i-button',
                        {
                            props: {
                                type: sliderType,
                                size: 'small',
                                ghost: true,
                            },
                        },
                        t.table.slider
                    ),
                ]);
            };
            const renderStatus = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.status === '0') {
                    color = 'success';
                    text = t.article.statusOption0;
                } else if (row.status === '1') {
                    color = 'error';
                    text = t.article.statusOption1;
                } else if (row.status === '2') {
                    color = 'success';
                    text = t.article.statusOption2;
                } else if (row.status === '9') {
                    color = 'success';
                    text = t.article.statusOption9;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderDefaultImg = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.dictId == null) {
                    color = 'success';
                    text = t.article.no;
                } else {
                    color = 'error';
                    text = t.article.yes;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderCharge = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.charge === '0') {
                    color = 'error';
                    text = t.article.charge1;
                } else if (row.charge === '1') {
                    color = 'success';
                    text = t.article.charge0;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderDisabled = (h, params) => {
                const row = params.row;
                let color = '';
                let text = '';
                if (row.disabled === '0') {
                    color = 'error';
                    text = t.article.yes;
                } else if (row.disabled === '1') {
                    color = 'success';
                    text = t.article.no;
                }
                return h(
                    'Tag',
                    {
                        props: {
                            type: 'border',
                            color: color,
                        },
                    },
                    text
                );
            };
            const renderAction = (h, params) => {
                const row = params.row;
                return (
                    <ButtonGroup>
                        <Button type="primary" size="small" to={'./edit/' + row.id}>
                            {msgUtil.message.action.edit}
                        </Button>
                        <Button type="error" size="small" on-click={$event => this.del($event, row)}>
                            {msgUtil.message.action.delete}
                        </Button>
                    </ButtonGroup>
                );
            };
            return {
                self: this,
                t: t,
                msgUtil: msgUtil,
                data: [],
                // 排序btn
                sortButton: [
                    {key: 'hits', value: t.article.hits, order: 0},
                    {key: 'disabled', value: t.article.disabled, order: 0},
                    {key: 'status', value: t.article.status, order: 0},
                    {key: 'releaseTime', value: t.article.releaseTime, order: 0},
                ],
                // 入力条件
                formItem: {
                    defaultImg: null,
                    dictId: null,
                    title: '',
                    author: '',
                    hot: null,
                    recommend: null,
                    recommendTop: null,
                    topic: null,
                    slider: null,
                    charge: '0',
                    hits: '',
                    status: '',
                    disabled: '',
                    releaseTime: '',
                    createStartTime: '',
                    createEndTime: '',
                    oa: '',
                    od: '',
                    size: 10,
                    current: 1,
                },
                checkAllGroup: [],
                categoryList: [
                    {name: t.article.hot, key: '0'},
                    {name: t.article.recommend, key: '1'},
                    {name: t.article.recommendTop, key: '2'},
                    {name: t.article.topic, key: '3'},
                    {name: t.article.slider, key: '4'},
                ],
                // table定义列
                columns: [
                    {title: '', type: 'selection', align: 'center', width: 44},
                    {title: t.table.id, key: 'id', align: 'center', width: 164},
                    {title: t.table.title, key: 'title', width: 164, tooltip: true, render: renderTitle},
                    {title: t.table.author, key: 'author', width: 164, tooltip: true},
                    {
                        title: t.table.defaultImg,
                        align: 'center',
                        key: 'defaultImg',
                        width: 140,
                        render: renderDefaultImg,
                    },
                    {title: t.table.category, align: 'center', key: 'category', width: 180, render: renderCategory},
                    {title: t.table.hits, key: 'hits', align: 'center', width: 100},
                    {title: t.table.charge, key: 'charge', align: 'center', width: 100, render: renderCharge},
                    {title: t.table.status, key: 'status', align: 'center', width: 120, render: renderStatus},
                    {title: t.table.createBy, key: 'createBy', width: 150, tooltip: true},
                    {title: t.table.releaseTime, key: 'releaseTime', width: 150},
                    {title: t.table.disabled, key: 'disabled', align: 'center', width: 100, render: renderDisabled},
                    {title: ' ', align: 'center'},
                    {
                        title: msgUtil.message.action.name,
                        key: 'operation',
                        align: 'center',
                        width: 130,
                        fixed: 'right',
                        render: renderAction,
                    },
                ],
                createStartTimeOption: {},
                createEndTimeOption: {},
                selectIds: [],
                total: 0,
                loading: false,
                delModal: false,
                delModalLoading: false,
                delCurId: null,
            };
        },
        methods: {
            gotoArticleHistory() {
                console.log(this.$router);
                this.$router.push({
                    name: 'content_article_history_list'
                });
            },
            //排序
            async orderClick(btn) {
                this.formItem.oa = '';
                this.formItem.od = '';
                if (btn.order === 1) {
                    this.formItem.oa = btn.key;
                } else if (btn.order === 2) {
                    this.formItem.od = btn.key;
                }
                await this.search(true);
            },
            // 检索数据
            async search(flg) {
                if (flg) {
                    this.formItem.current = 1;
                    this.$refs.page.currentPage = 1;
                }
                this.loading = true;
                await this.wrapperCreateTime();
                let articleDto = {};
                articleDto.title = this.formItem.title;
                articleDto.dictId = this.formItem.defaultImg;
                articleDto.author = this.formItem.author;
                articleDto.status = this.formItem.status;
                articleDto.disabled = this.formItem.disabled;
                articleDto.body = this.formItem.body;
                articleDto.releaseTime = this.formItem.releaseTime;
                articleDto.oa = this.formItem.oa;
                articleDto.od = this.formItem.od;
                if (this.formItem.oa === '' && this.formItem.od === '') {
                    articleDto.od = 'releaseTime';
                }
                articleDto.current = this.formItem.current;
                articleDto.size = this.formItem.size;
                const result = await getArticleList(articleDto);
                if (result) {
                    this.data = result.page.records;
                    this.total = result.page.total;
                }
                this.loading = false;
            },
            //创建时间作成
            async wrapperCreateTime() {
                this.formItem.releaseTime = '';
                if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                    this.formItem.releaseTime = this.formItem.createStartTime + ',';
                }
                if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                    if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                        this.formItem.releaseTime = ',';
                    }
                    this.formItem.releaseTime += this.formItem.createEndTime;
                }
            },
            // 页号改变
            async pageChange() {
                this.formItem.current = this.$refs.page.currentPage;
                await this.search(false);
            },
            // 每页显示数据
            async pageSizeChange() {
                this.formItem.size = this.$refs.page.currentPageSize;
                await this.search(false);
            },
            // 删除
            async del(event, row) {
                this.delCurId = row.id;
                this.delModal = true;
            },
            // 批量删除
            async delAll() {
                if (this.selectIds.length === 0) {
                    Message.error({
                        content: this.msgUtil.message.warn.notSelectedRow,
                        duration: 60,
                        closable: true,
                    });
                    return;
                }
                this.delModal = true;
            },
            // 行选择
            rowSelect(selection) {
                this.selectIds = selection.map(p => {
                    return {id: p.id};
                });
            },
            /**
             * 开始时间发生变化时触发,设置结束时间不可选择的日期
             * 结束时间应大于等于开始时间,且小于等于当前时间
             * @param {string} startTime 格式化后的日期
             * @param {string} type 当前的日期类型
             */
            onStartTimeChange(startTime, type) {
                this.formItem.createStartTime = startTime;
                this.createEndTimeOption = {
                    disabledDate(endTime) {
                        return endTime < new Date(startTime) || endTime > Date.now();
                    },
                };
            },
            /**
             * 结束时间发生变化时触发,设置开始时间不可选择的日期
             * 开始时间小于等于结束时间,且小于等于当前时间
             * @param {string} date 格式化后的日期
             * @param {string} type 当前的日期类型
             */
            onEndTimeChange(endTime, type) {
                this.formItem.createEndTime = endTime;
                this.createStartTimeOption = {
                    disabledDate(startTime) {
                        return startTime > new Date(endTime) || startTime > Date.now();
                    },
                };
            },
            checkAllGroupChange(data) {
                this.formItem.hot = null;
                this.formItem.recommend = null;
                this.formItem.recommendTop = null;
                this.formItem.topic = null;
                this.formItem.slider = null;
                for (let i = 0; i < data.length; i++) {
                    if ('0' === data[i]) {
                        this.formItem.hot = '1';
                    } else if ('1' === data[i]) {
                        this.formItem.recommend = '1';
                    } else if ('2' === data[i]) {
                        this.formItem.recommendTop = '1';
                    } else if ('3' === data[i]) {
                        this.formItem.topic = '1';
                    } else if ('4' === data[i]) {
                        this.formItem.slider = '1';
                    }
                }
            },
            // 删除取消
            async handleDeleteCancel() {
                this.delModalLoading = false;
                this.delModal = false;
            },
            // 删除
            async handleDelete() {
                if( this.delCurId !== null){
                    await del(this.delCurId);
                    this.delCurId = null;
                }else{
                    await delAll(this.selectIds);
                }
                await this.search(true);
                await this.handleDeleteCancel();
            },
        },
        async mounted() {
            await this.search(true);
        },
    };
</script>
<style>
</style>
